export default "__VITE_ASSET__42e99b3a__"